<template>
  <div
    class="user-avatar"
    :class="{ 'avatar-online': isOnline }"
  >
    <div
      :class="['user-avatar-bg', sizeClass]"
      :style="{ backgroundColor: bgColor }"
    >
      <template v-if="isLoading">
        <div class="skeleton w-full h-full rounded-full!" />
      </template>
      <template v-else>
        <img
          v-if="!!userImg"
          :src="userImg"
        />
        <span
          v-else
          class="user-avatar-initials"
        >
          {{ initials }}
        </span>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { AvatarColorsByInitials } from '@/constants/colors';

const props = defineProps({
  userImg: {
    type: String,
    default: null,
  },
  userName: {
    type: String,
    default: '',
  },
  isOnline: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'sm',
    validator: (value) => ['xs', 'sm'].includes(value),
  },
});

const initials = computed(() => {
  const names = props.userName.split(' ') || [];
  if (names.length === 0) return '';
  const initials = names.length > 1 ? names[0].charAt(0) + names[names.length - 1].charAt(0) : names[0].charAt(0);
  return initials.toUpperCase();
});

const sizeClass = computed(() => {
  return {
    xs: 'is-xs',
    sm: 'is-sm',
  }[props.size];
});

const bgColor = computed(() => {
  return {
    true: 'var(--color-gray-50)',
    false: AvatarColorsByInitials[initials.value.charAt(0)],
  }[props.isLoading];
});
</script>

<style>
@reference '@/assets/main.css';

.user-avatar {
  @apply avatar avatar-placeholder;
}

.user-avatar-bg {
  @apply rounded-full border border-white/33;

  &.is-xs {
    @apply w-8 h-8;
  }
  &.is-sm {
    @apply w-10 h-10;
  }
}

.user-avatar-initials {
  @apply text-white font-semibold;
}
</style>
